export const KPIS = ["sales", "collection", "scheme"];
export const KPI_COLORS = {
  sales: { color: "#1B4332", bg: "#D8F3DC" },
  collection: { color: "#457B9D", bg: "#DCE9F0" },
  scheme: { color: "#C56950", bg: "#FADED7" },
};
export const financialYearFor = (month) => {
  const [year, number] = month.split("-").map(Number);
  return number >= 4 ? year : year - 1;
};
export const fyLabel = (year) => `FY ${year}–${String(year + 1).slice(-2)}`;
export const monthLabel = (month) => new Date(`${month}-01T12:00:00`).toLocaleDateString("en-IN", { month: "short", year: "numeric" });
export const percent = (achieved, target) => target > 0 ? Math.round(achieved / target * 1000) / 10 : null;